import React from "react";
import { useRouter } from "next/router";
import styles from "./InsightCards.module.scss";

const ICON_COLORS = {
    strongest: "#009448",
    opportunity: "#E2B93B",
    pressure: "#C54E3F",
    operational_roi: "#E2B93B",
    people_gap: "#1391BC",
    change_ready: "#0B5D3B",
};

export default function InsightCards({ insights }) {
    const { locale } = useRouter();

    if (!insights || insights.length === 0) return null;

    return (
        <div className={styles.insightsContainer}>
            {insights.map((insight, i) => {
                const title =
                    locale === "en" ? insight.title_en : insight.title_is;
                const desc =
                    locale === "en" ? insight.desc_en : insight.desc_is;
                const color = ICON_COLORS[insight.type] || "#7a8a9e";

                return (
                    <div key={i} className={styles.card}>
                        <span className={styles.icon} style={{ color }}>
                            {insight.icon}
                        </span>
                        <div className={styles.text}>
                            <h4 className={styles.title}>{title}</h4>
                            <p className={styles.desc}>{desc}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
